export const Coupon = (json: ICoupon): ICouponModel => {
	const fromJSON = (itemJson: ICoupon) => {
		const {
			promotion_id,
			usage_count,
			usage_limit,
			per_customer_usage_limit,
			expires_at,
			created_at,
			updated_at,
			...rest
		} = itemJson
		return {
			promotionID: promotion_id,
			usageCount: usage_count,
			usageLimit: usage_limit,
			perCustomerUsageLimit: per_customer_usage_limit,
			expiresAt: expires_at,
			createdAt: created_at,
			updatedAt: updated_at,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const couponToJSON = (obj: Partial<ICouponModel>): Partial<ICoupon> => {
	const { usageLimit, perCustomerUsageLimit, ...rest } = obj
	return {
		usage_limit: usageLimit ?? null,
		per_customer_usage_limit: perCustomerUsageLimit ?? null,
		...rest,
	}
}
